import React, { useEffect } from "react";
import { StyleSheet } from "react-native";
import { testProps } from "app/shared/util/test-props";
import Animated, {
  Easing,
  Extrapolate,
  interpolate,
  useAnimatedStyle,
  useSharedValue,
  withRepeat,
  withTiming,
} from "react-native-reanimated";
import images from "app/shared/styles/images";

const AnimatedImageView = () => {
  const animation = useSharedValue(0);
  const animatedStyles = useAnimatedStyle(() => {
    const scale = interpolate(animation.value, [0, 1], [1, 1.15], Extrapolate.CLAMP);
    return {
      // opacity,
      transform: [
        {
          scale,
        },
      ],
    };
  });

  const imagesAnimatedStyles = useAnimatedStyle(() => {
    const opacity = interpolate(animation.value, [0, 1], [0.65, 1], Extrapolate.CLAMP);
    return {
      opacity,
    };
  });

  useEffect(() => {
    animation.value = withRepeat(
      withTiming(1, {
        duration: 1000,
        easing: Easing.linear,
      }),
      -1,
      true,
    );
  }, [animation]);

  return (
    <Animated.View style={[styles.container, animatedStyles]} {...testProps("loadingModal")}>
      <Animated.Image style={[styles.imageStyle, imagesAnimatedStyles]} source={images.avatar_default} />
    </Animated.View>
  );
};

const LoadingModal = () => {
  return <AnimatedImageView />;
};

const styles = StyleSheet.create({
  container: {
    width: 128,
    height: 128,
    padding: 16,
    alignSelf: "center",
    backgroundColor: "white",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 12,
  },
  imageStyle: {
    width: 96,
    height: 96,
    resizeMode: "contain",
  },
});

export default LoadingModal;
